<button
type="button"
class="close pull-right"
aria-label="close"
(click)="close()"
>
<span aria-hidden="true">×</span>
</button>
<div class="page-wrapper p-3 fd-pop">
  <div class="container p0">
    <div class="row">
      <div class="col-md-12 mb-4 mt-4">
        <form
          id="virtuefeedback"
          class="form-horizontal feedback ed-form"
          role="form"
          [formGroup]="feedBackForm"
        >
          <div class="form-group">
            <div class="col-md-12 mb-3">
              <h1>Feedback</h1>
             
            </div>
          </div>
          <div class="form-group">
            <div class="col-lg-12 mb-4">
              <h3 class="virtue-title">
                Please provide the information below and hit "send" to submit
                your feedback for review. If you would like us to contact you
                please include your email or mobile no. in the comments.
              </h3>
            </div>
          </div>

          <!-- <div class="col-md-12 mb-4 mt-1"> -->
          <!-- <form id="form"> -->
          <!-- <div class="row"> -->
          <div *ngFor="let info of feedBackFormData" class="fedback">
            <div class="form-group p-0">
              <div class="col-lg-12">
                <ng-container>
                  <lib-virtue-form
                    [inputWidget]="info"
                    (validated)="formValid($event)"
                    (errorInput)="errorInput($event)"
                    (addInput)="changeinputinformfilled($event)"
                    (removeInput)="removeinput($event)"
                    [widgetno]="0"
                    [configId]="info.configId"
                    [showError]="showError"
                    [disabled]="getDisabled(info)"
                    [value]="getValue(info)"
                    [altValue]="getaltValue(info)"
                    [outerClassUsed]="true"
                  >
                  </lib-virtue-form>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="form-group row pt-3text-center">
            <div class="col">
              <div class="p-4">
              <!-- <a class="page-btn mx-1" (click)="close()">Close</a> -->
              <button  class="page-btn mx-1"
                (click)="onSubmitForm()"
                [disabled]="!isValid"
                [ngClass]="!isValid ? 'cursor-not-allowed' : ''"
                >Send</button >
                </div>
            </div>
          </div>

        
        </form>
      </div>
    </div>
  </div>
</div>
